type GAEventParams = {
  category: string
  action: string
  label?: string
  value?: string | number
}

type FBEventParams = {
  event: string
  value?: string | number
  currency?: string
  predicted_ltv?: string
}

type LogEventParams = {
  ga?: GAEventParams
  fb?: FBEventParams
}

type LogPageviewParams = {
  customPage: string
}

type UserDataParams = {
  user_id: string
}

export type GaEcommerce = null | {
  currency?: string
  value?: number
  coupon?: string
  payment_type?: string
  items?: {
    item_id?: string
    item_name?: string
    affiliation?: string
    coupon?: string
    currency?: string
    discount?: number
    index?: number
    item_brand?: string
    item_category?: string
    item_category2?: string
    item_category3?: string
    item_category4?: string
    item_category5?: string
    item_list_id?: string
    item_list_name?: string
    item_variant?: string
    location_id?: string
    price?: number
    quantity?: number
  }[]
}

type EcommerceParams = {
  ecommerce_type: string
  ecommerce: null | GaEcommerce
}

type GTMParams = {
  event: string
} & (LogEventParams | LogPageviewParams | UserDataParams | EcommerceParams)

function isDataInvalid(data: GTMParams): boolean {
  return typeof data.event !== 'string'
}

export function gtmPush(data: GTMParams): void {
  if (!window || !window.dataLayer) return

  if (!isDataInvalid(data)) {
    window.dataLayer.push(data)
  }
}

export function logPageview(customDimensions = {}): void {
  const customData = {
    customPage: `${window.location.pathname}${window.location.search}`,
    ...customDimensions,
  }

  gtmPush({
    event: 'trackPageview',
    ...customData,
  })
}

export function logEvent({ ga, fb }: LogEventParams): void {
  gtmPush({
    event: 'Track Custom Event',
    ga,
    fb,
  })
}

export function logUser(id?: string): void {
  gtmPush({
    event: 'userData',
    user_id: id ?? '',
  })
}

export function logEcommerce(
  name: string,
  ecommerce: EcommerceParams['ecommerce'],
): void {
  gtmPush({
    event: 'Ecommerce',
    ecommerce_type: name,
    ecommerce,
  })
}
